export async function handleUpdateArray(updatedData, type, payload, userDataContext) {
    const { token, dispatch } = userDataContext
    let reqBody = {}

    if(type.includes("CART")) {
        reqBody.cart = updatedData
    } else if(type.includes("WISHLIST")) {
        reqBody.wishlist = updatedData
    } else if(type.includes("PROFILE")) {
        reqBody = updatedData
    }
    //${process.env.REACT_APP_API_BASE_URL}
    const response = await fetch(`http://localhost:3001/api/updateUser`, {
    //const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/updateUser`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify(reqBody)
    })
    const json = await response.json()

    if(response.ok) {
        const { user } = json
        localStorage.setItem("user", JSON.stringify({ user, token }))
        dispatch({ type, payload })
        console.log(json)
    } else {
        console.log(json)
    }
}